import {inter, white} from "../../Theme";
import {ScoreIndicatorIcon} from "./PlanOfActionOverview";
import styled, { css } from "styled-components";
import {device} from "../../constants/breakpoints";
import {determineSkill} from '../../util/Helpers';

const StyledOverViewCard = styled.div`
    flex: 1;
    max-width: ${({$pdfExport}) => ($pdfExport ? "100%" : "45%")};
    background: ${white};
    padding: 30px 36px;
    display: flex;
    flex-direction: column;

    ${({$pdfExport}) => $pdfExport ? css`
        max-width: 100%;
    ` : css`
        max-width: 45%;

        @media screen and ${device.laptopL} {
            max-width: 590px;
            width: 100%;
        }
        
        @media screen and ${device.mobileL} {
            padding: 20px 24px;
        }
    `};
`;

const OverViewCardRoot = styled.div`
    width: 100%; 
    display: block;
`;

const OverViewHeader = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
`;

const HeaderLabel = styled.div`
    font-family: ${inter};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    opacity: 0.7;
`;

const TitleHeader = styled(HeaderLabel)`
    width: 45%;
    @media screen and ${device.mobileL} {
        width: ${({$pdfExport}) => ($pdfExport ? "45%" : "70%")};
    }
`;

const IndicatorHeader = styled(HeaderLabel)`
    width: 45%;
    @media screen and ${device.mobileL} {
        width: ${({$pdfExport}) => ($pdfExport ? "45%" : "20%")};
    }
`;

const ScoreHeader = styled(HeaderLabel)`
    width: 10%;
`;

const ProgressListItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

function OverViewCard({period, pdfExport = false, ...props}) {

    return (
        <StyledOverViewCard $pdfExport={pdfExport}>
            <OverViewCardRoot {...props}>
                <OverViewHeader>
                    <TitleHeader $pdfExport={pdfExport}>Executieve Functies</TitleHeader>
                    <IndicatorHeader $pdfExport={pdfExport}>Niveau</IndicatorHeader>
                    <ScoreHeader>Score</ScoreHeader>
                </OverViewHeader>
                <ProgressListItems>
                    {(period ? period.scoresPerExecutiveFunction : []).map((ef, i) => (
                        <ProgressListItem
                            key={ef.title}
                            index={i + 1} title={ef.title}
                            totalScore={ef.totalScore}
                            averageScore={ef.averageScore}
                            skillScale={{beginner: period.beginner, developing: period.developing, mastered: period.mastered}}
                            pdfExport={pdfExport}
                        />
                    ))}
                </ProgressListItems>
            </OverViewCardRoot>
        </StyledOverViewCard>
    );
}

const ScoreRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const ScoreTitle = styled.div`
    width: 45%;
    font-family: ${inter};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    
    @media screen and ${device.mobileL} {
        width: ${({$pdfExport}) => ($pdfExport ? "45%" : "70%")};
    }
`;

const ScoreIndicatorRoot = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    width: 45%;
    
    @media screen and ${device.mobileL} {
        width: ${({$pdfExport}) => ($pdfExport ? "45%" : "20%")};
    }
`;

const Score = styled.div`
    width: 10%;
    font-family: ${inter};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
`;

const ScoreText = styled.div`
    font-family: ${inter};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    
    @media screen and ${device.mobileL} {
        display: ${({$pdfExport}) => ($pdfExport ? "block" : "none")};
    }
`;

function ProgressListItem({skillScale, pdfExport = false, ...props}) {
    const determinedSkill = determineSkill(props.totalScore, skillScale);

    return (
        <ScoreRow>
            <ScoreTitle $pdfExport={pdfExport}>{props.index}. {props.title}</ScoreTitle>
            <ScoreIndicatorRoot $pdfExport={pdfExport}>
                <ScoreIndicatorIcon
                    totalScore={props.totalScore}
                    determinedSkill={determinedSkill}
                    pdfExport={pdfExport}
                />
                <ScoreText $pdfExport={pdfExport}>{determinedSkill?.label}</ScoreText>
            </ScoreIndicatorRoot>
            <Score>
                {props.totalScore}
            </Score>
        </ScoreRow>
    );
}

export default OverViewCard;